import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'
import PropTypes from 'prop-types'

import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import {
  Box,
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import PageHeader from '@components/PageHeader'

import usePaymentMethod, { usePaymentMethodForm } from '@hooks/usePaymentMethod'

import Details from '../Details'

const PageContent = (props) => {
  const { paymentMethodId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updatePaymentMethod,
    },
  } = pageContext

  const paymentMethodPayload = usePaymentMethod({ id: paymentMethodId })
  const {
    callbacks: {
      updatePaymentMethod: updateFn,
    },
    loaded,
    loading,
    paymentMethod,
    updating,
    urls: {
      paymentMethodsIndexUrl,
    },
  } = paymentMethodPayload

  const paymentMethodFormPayload = usePaymentMethodForm(paymentMethod)
  const { entityState, saveEnabled } = paymentMethodFormPayload

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const updatePaymentMethodPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Payment Method Updated',
  }

  return (
    <>
      <Helmet>
        <title>Payment Methods | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || paymentMethodsIndexUrl}
            size="medium"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey="details"
        tabBarItems={[
          {
            icon: faIdCard,
            key: 'details',
            title: 'Payment Method Details',
          },
        ]}
        title="Edit Payment Method"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading && !loaded} times={3} />

            {loaded && <Details paymentMethodFormPayload={paymentMethodFormPayload} />}

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                onClick={() => updatePaymentMethod(updatePaymentMethodPayload)}
                size="medium"
                style={{ width: '100%' }}
              >
                Save Details
              </Button>
            </SaveFormModule>
          </Columns.Main>
        </Columns>
      </Box>
    </>
  )
}

PageContent.propTypes = {
  paymentMethodId: PropTypes.number.isRequired,
}

export default PageContent
